import { useState, useEffect } from 'react';

export const useTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const checkTouchDevice = () => {
      const hasTouchSupport = navigator.maxTouchPoints > 0;

      if (!hasTouchSupport) {
        return false;
      }

      const hasMouseSupport = matchMedia('(pointer:fine)').matches;

      return hasTouchSupport && !hasMouseSupport;
    };

    setIsTouchDevice(checkTouchDevice());

    const handleResize = () => {
      setIsTouchDevice(checkTouchDevice());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isTouchDevice;
}; 